module.exports = __webpack_public_path__ + "assets/img/email-c2c50245.png";